import { createFileRoute } from '@tanstack/react-router';

import { TravelRequestLoadError } from '@/module/Travel/Request/TravelRequestLoadError';
import { getTravelRequestOptions } from '@/module/Travel/Request/model/TravelRequestQuery';

export const Route = createFileRoute('/_auth/travel/_travel/requests/$requestId/_layout')({
  loader: async ({ params: { requestId }, context: { queryClient } }) => {
    const request = await queryClient.ensureQueryData(getTravelRequestOptions(requestId));

    return {
      request,
      crumb: request.name ?? request.activityType,
    };
  },
  errorComponent: TravelRequestLoadError,
});
